import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { isPreviewHost } from "@/lib/selfheal";

// Preview-only fault probe (?fmo_fault=crash|crash2|chunk|503&key=…) used by the robot training and the tester.
let crashedOnce = false;
window.addEventListener("fmo:heal-caught", () => {
  crashedOnce = true;
});
const fault = () => (isPreviewHost() ? new URLSearchParams(window.location.search).get("fmo_fault") : null);

const Bomb = ({ always }) => {
  if (always || !crashedOnce) throw new Error("selfheal test: simulated component crash");
  return <span className="sr-only" data-testid="heal-fault-crash-recovered">recovered</span>;
};

let flakyStarted = false; // StrictMode runs effects twice in dev: one probe request only

const Flaky = () => {
  const [res, setRes] = useState("pending");
  useEffect(() => {
    if (flakyStarted) return;
    flakyStarted = true;
    const key = new URLSearchParams(window.location.search).get("key") || "probe";
    api.get(`/selfheal/flaky/${key}`).then(({ data }) => setRes(`ok:${data.attempts}`)).catch((e) => setRes(`fail:${e?.response?.status || "net"}`));
  }, []);
  return <span className="fixed bottom-2 start-2 z-50 rounded bg-black/80 px-2 py-1 text-xs text-white" data-testid="heal-fault-503-result">{res}</span>;
};

const Chunk = () => {
  useEffect(() => {
    Promise.reject(Object.assign(new Error("Loading chunk 777 failed."), { name: "ChunkLoadError" }));
  }, []);
  return null;
};

export const FaultProbe = () => {
  const f = fault();
  if (f === "crash" || f === "crash2") return <Bomb always={f === "crash2"} />;
  if (f === "503") return <Flaky />;
  if (f === "chunk") return <Chunk />;
  return null;
};
